/**
 * Filter nonZero values
 * @param  {Number} value The value to Filter
 * @return {Boolean} true if value is nonZero, false otherwise
 */
export default function (value) {
  return value !== 0;
}
